import 'classlist-polyfill';

import objectFitImages from 'object-fit-images';
import responsiveVideos from './components/layout/responsiveVideos';
import quantitySelect from './components/layout/quantitySelect';
import validation from './components/forms/validation';
import { form } from './components/forms/form';
import ModalManager from './components/modals/ModalManager';
import PredictiveSearch from './components/search/PredictiveSearch';
import CartModal from './components/cart/CartModal';
import navigation from './components/layout/navigation';
import promoModal from './components/modals/promoModal';
import subscribe from './components/forms/subscribe';
import subscribeAutofill from './components/forms/subscribeAutofill';

import Contact from './pages/Contact';
import Components from './pages/Components';
import CustomersAddresses from './pages/CustomersAddresses';
import Product from './pages/Product';
import accordion from './components/layout/accordion';
import Disclosure from './components/layout/Disclosure';
import slideshow from './components/layout/slideshow';
import Index from './pages/Index';

require('./utils/nativeConsole');

// Set js class
const htmlClassList = document.documentElement.classList;
htmlClassList.add('js');
htmlClassList.remove('no-js');

window.modalManager = new ModalManager();

// Layout setup
navigation();
responsiveVideos();
slideshow();
quantitySelect();
accordion();
objectFitImages();
subscribeAutofill();

// Forms
validation();

// Subscription in Active Campaign
subscribe();

// Promo modal
promoModal();

if (document.getElementById('form-newsletter')) {
  form('#form-newsletter');
}

// Cart
window.cartModal = new CartModal();

// Search
const searchBars = document.querySelectorAll('.search-bar');
searchBars.forEach(el => {
  // eslint-disable-next-line no-new
  new PredictiveSearch(el);
});

// Disclosure
const disclosures = document.querySelectorAll('.disclosure');
disclosures.forEach(el => {
  // eslint-disable-next-line no-new
  new Disclosure(el);
});

// Enable this if you want to test ga calls in development
// gaDevelopment();

// Page specific classes
const pages = {
  Contact,
  Components,
  CustomersAddresses,
  Product,
  Index,
};

// Get page class from template datapage
const currentPage = `-${document.documentElement.getAttribute('data-page')}`;
if (currentPage) {
  const pageClassName = currentPage.split('-').reduce((accumulator, currentValue) => {
    return accumulator + currentValue.charAt(0).toUpperCase() + currentValue.slice(1);
  });

  if (pageClassName !== '' && typeof pages[pageClassName] === 'function') {
    new pages[pageClassName](); // eslint-disable-line no-new
  }
}

window.modalManager.checkModalOnPageLoad();
